import LegalLayout from '../components/LegalLayout';

const Article = ({ num, title, children }: { num: string; title: string; children: React.ReactNode }) => (
  <article className="mb-10">
    <h2 className="text-lg font-bold text-[#C9A227] mb-4 flex items-center gap-3">
      <span className="text-xs font-mono text-white/20 w-8">ART.</span>
      <span>{num} — {title}</span>
    </h2>
    <div className="pl-11 space-y-3 text-white/70 text-sm leading-relaxed">
      {children}
    </div>
  </article>
);

const Field = ({ label, value }: { label: string; value: string }) => (
  <div className="flex flex-col sm:flex-row sm:gap-4">
    <span className="text-white/30 text-xs uppercase tracking-wide w-40 shrink-0 pt-0.5">{label}</span>
    <span className="text-white/80">{value}</span>
  </div>
);

export default function MentionsLegalesPage() {
  return (
    <LegalLayout
      title="Mentions légales"
      subtitle="Conformes à la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique (LCEN), article 6"
    >
      <div className="bg-[#0D1228] border border-white/[0.07] rounded-lg p-6 mb-10 text-xs text-white/40 flex items-start gap-3">
        <i className="ri-information-line text-[#C9A227] text-base mt-0.5 shrink-0"></i>
        <p>
          Conformément aux dispositions de l&apos;article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l&apos;économie numérique, il est précisé aux utilisateurs du site <strong className="text-white/60">lereseausportif.com</strong> l&apos;identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
        </p>
      </div>

      <Article num="1" title="Éditeur du site">
        <div className="bg-[#080C1E] rounded-lg border border-white/[0.05] p-5 space-y-3">
          <Field label="Identité" value="MADAME AURELIE PINTO" />
          <Field label="Statut juridique" value="Micro-entrepreneur" />
          <Field label="Nom commercial" value="AD.NOVA.PRO" />
          <Field label="Activité" value="Réseau Sport &amp; Business — accompagnement à la reconversion des sportifs professionnels" />
          <Field label="Code NAF" value="7022Z — Conseil pour les affaires et autres conseils de gestion" />
          <Field label="SIRET" value="100 385 756 00018" />
          <Field label="Immatriculation" value="27 janvier 2026" />
          <Field label="Adresse" value="2 allée des jardins de Courrejean, 33140 Villenave-d'Ornon" />
          <Field label="Téléphone" value="06 14 12 68 69" />
          <Field label="Email" value="ad.nova.pro33@gmail.com" />
        </div>
      </Article>

      <Article num="2" title="Directeur de la publication">
        <p>
          Le directeur de la publication du site <strong className="text-white/80">lereseausportif.com</strong> est Madame Aurélie Pinto, en sa qualité d&apos;éditeur responsable du site.
        </p>
        <p>
          Contact : <a href="mailto:ad.nova.pro33@gmail.com" className="text-[#C9A227] hover:underline">ad.nova.pro33@gmail.com</a>
        </p>
      </Article>

      <Article num="3" title="Hébergeur du site">
        <div className="bg-[#080C1E] rounded-lg border border-white/[0.05] p-5 space-y-3">
          <Field label="Nom" value="Readdy.ai" />
          <Field label="Site" value="readdy.ai" />
          <Field label="Adresse légale" value="À compléter sur readdy.ai" />
        </div>
        <p className="mt-3">
          L&apos;hébergeur est responsable des conditions techniques de mise en ligne du site. En cas de contenu illicite, il peut être contacté afin d&apos;assurer la mise en œuvre des obligations légales qui lui incombent.
        </p>
      </Article>

      <Article num="4" title="Activité et objet social">
        <p>
          Le site <strong className="text-white/80">lereseausportif.com</strong>, édité sous la marque <strong className="text-white/80">AD.NOVA.PRO</strong>, est un réseau privé Sport &amp; Business dédié à l&apos;accompagnement des sportifs professionnels et semi-professionnels dans leur reconversion vers l&apos;entrepreneuriat.
        </p>
        <p>
          AD.NOVA.PRO propose notamment :
        </p>
        <ul className="list-disc list-inside space-y-1 text-white/60 pl-2">
          <li>Des abonnements à un réseau privé d&apos;entraide et de mise en relation</li>
          <li>L&apos;accès à un réseau d&apos;experts qualifiés (avocat, comptable, CGP, courtier…)</li>
          <li>L&apos;organisation d&apos;événements de networking exclusifs</li>
          <li>Un accompagnement structuré à la reconversion professionnelle</li>
        </ul>
      </Article>

      <Article num="5" title="Régime fiscal — Franchise en base de TVA">
        <p>
          Madame Aurélie Pinto, micro-entrepreneur, bénéficie de la franchise en base de TVA prévue à l&apos;article 293 B du Code général des impôts.
        </p>
        <p>
          À ce titre, la TVA n&apos;est pas applicable aux prestations et services proposés sur le site lereseausportif.com. La mention <em className="text-white/50">« TVA non applicable — article 293 B du CGI »</em> figure sur l&apos;ensemble des documents commerciaux émis par AD.NOVA.PRO.
        </p>
      </Article>

      <Article num="6" title="Propriété intellectuelle">
        <p>
          L&apos;ensemble du contenu du site <strong className="text-white/80">lereseausportif.com</strong> (textes, visuels, logo, structure, charte graphique) est la propriété exclusive de Madame Aurélie Pinto, sous réserve des droits des tiers, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l&apos;autorisation préalable et écrite de Madame Aurélie Pinto.
        </p>
        <p>
          Toute exploitation non autorisée est susceptible de constituer une contrefaçon au sens des articles L.335-2 et suivants du Code de la propriété intellectuelle.
        </p>
      </Article>

      <Article num="7" title="Protection des données personnelles">
        <p>
          Le traitement des données personnelles collectées sur le site lereseausportif.com est effectué conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à la loi Informatique et Libertés n° 78-17 du 6 janvier 1978 modifiée.
        </p>
        <p>
          Le responsable du traitement est Madame Aurélie Pinto. Les données collectées sont utilisées exclusivement dans le cadre de la relation contractuelle et de la fourniture des services proposés sur lereseausportif.com.
        </p>
        <p>
          Conformément à la réglementation en vigueur, vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement, de portabilité et d&apos;opposition sur vos données personnelles. Pour exercer ces droits, contactez-nous à l&apos;adresse : <a href="mailto:ad.nova.pro33@gmail.com" className="text-[#C9A227] hover:underline">ad.nova.pro33@gmail.com</a>.
        </p>
        <p>
          En cas de réclamation non résolue, vous pouvez saisir la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="nofollow noopener noreferrer" className="text-[#C9A227] hover:underline">www.cnil.fr</a>).
        </p>
      </Article>

      <Article num="8" title="Cookies">
        <p>
          Le site lereseausportif.com utilise des cookies. Pour en savoir plus sur les cookies utilisés, leur finalité et comment les paramétrer, consultez notre{' '}
          <a href="/legal/cookies" className="text-[#C9A227] hover:underline">Politique de gestion des cookies</a>.
        </p>
      </Article>

      <Article num="9" title="Limitation de responsabilité">
        <p>
          Madame Aurélie Pinto s&apos;efforce d&apos;assurer l&apos;exactitude et la mise à jour des informations diffusées sur lereseausportif.com, mais ne peut garantir l&apos;exhaustivité, l&apos;exactitude ou l&apos;actualité des informations publiées.
        </p>
        <p>
          L&apos;éditeur décline toute responsabilité pour tout dommage direct ou indirect résultant de l&apos;accès au site, de l&apos;utilisation des informations qui y figurent ou de toute interruption de service.
        </p>
        <p>
          Les liens hypertextes présents sur le site vers des sites tiers n&apos;engagent pas la responsabilité de l&apos;éditeur quant au contenu de ces sites.
        </p>
      </Article>

      <Article num="10" title="Droit applicable — Juridiction compétente">
        <p>
          Les présentes mentions légales sont régies par le droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux compétents seront ceux du ressort du Tribunal judiciaire de Bordeaux.
        </p>
      </Article>

      <div className="mt-12 pt-8 border-t border-white/[0.07] text-center">
        <p className="text-xs text-white/25">Dernière mise à jour : mars 2026 — lereseausportif.com</p>
      </div>
    </LegalLayout>
  );
}
